import { Button as BaseButton, buttonClasses } from "@mui/base/Button";
import { styled } from "@mui/system";
import Stack from "@mui/material/Stack";
import { blue, grey } from "./CutomColor";

interface CustomButtonProps {
  id?: string;
  text?: string;
  variant?: string;
  onClick?: () => void;
}

export default function CustomButton({
  id,
  text,
  variant,
  onClick,
}: CustomButtonProps) {
  return (
    <Stack spacing={2} direction="row" id={id}>
      {variant === "outlined" ? (
        <OutlinedButton variant="text" onClick={onClick}>
          {text}
        </OutlinedButton>
      ) : (
        <ContainedButton variant="text" onClick={onClick}>
          {text}
        </ContainedButton>
      )}
    </Stack>
  );
}

const ContainedButton = styled(BaseButton)`
  font-size: 1rem;
  line-height: 1.5;
  background-color: var(--contained-bg);
  padding: 8px 16px;
  border-radius: 8px;
  color: var(--contained-text);
  transition: all 150ms ease;
  cursor: pointer;
  border: 1px solid var(--contained-bg);
  box-shadow: 0 2px 1px rgba(45, 45, 60, 0.2);

  &:hover {
    background-color: var(--contained-bg-hover);
  }

  &.${buttonClasses.active} {
    background-color: var(--contained-bg-active);
    box-shadow: none;
    transform: scale(0.99);
  }

  &.${buttonClasses.focusVisible} {
    box-shadow: 0 0 0 4px var(--contained-focus-ring);
    outline: none;
  }

  &.${buttonClasses.disabled} {
    background-color: var(--contained-disabled-bg);
    color: var(--contained-disabled-text);
    border: none;
    cursor: default;
    box-shadow: none;
    transform: scale(1);
  }
`;

const OutlinedButton = styled(BaseButton)`
  font-size: 0.875rem;
  line-height: 1.5;
  background-color: var(--outlined-bg);
  padding: 8px 16px;
  border-radius: 8px;
  color: var(--outlined-text);
  transition: all 150ms ease;
  cursor: pointer;
  border: 1px solid var(--outlined-border);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: var(--outlined-bg-hover);
    color: var(--outlined-text-hover);
  }

  &.${buttonClasses.active} {
    background-color: var(--outlined-bg-active);
    color: var(--outlined-text-hover);
    box-shadow: none;
    transform: scale(0.99);
  }

  &.${buttonClasses.focusVisible} {
    box-shadow: 0 0 0 4px var(--outlined-focus-ring);
    outline: none;
  }

  &.${buttonClasses.disabled} {
    background-color: var(--outlined-disabled-bg);
    color: var(--outlined-disabled-text);
    border: none;
    cursor: default;
    box-shadow: none;
    transform: scale(1);
  }
`;
